import Swal from 'sweetalert2';
import { writable } from 'svelte/store';
import 'sweetalert2/dist/sweetalert2.css';

export let key = writable("");
export let username = writable("");
export let password = writable("");
export let confirmPassword = writable("");
export let email = writable("");
export let confirmationСode = writable("");
export let errorUsernameMessage = writable(""),
    errorAlertMessage = writable("");
export let errorEmailMessage = writable(""),
    errorPasswordMessage = writable(""),
    errorBotMessage = writable("");

let guid = () => {
    let s4 = () => {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export async function InitForm() {
    let key_ = guid();
    key.set(key_);
}

export async function isUniqueName() {
    let key_ = "";
    let unsubscribe = key.subscribe(value => {
        key_ = value;
    });

    let username_ = "";
    let unsubscribe1 = username.subscribe(value => {
        username_ = value;
    });

    if (username_.length < 4) {
        errorUsernameMessage.set("Это имя пользователя очень короткое");
        return false;
    } else if (username_.length > 50) {
        errorUsernameMessage.set("Это имя пользователя очень длинное");
        return false;
    }

    let url = "/is_unique/?key=" + key_ + "&uname=" + username_;
    let response = await fetch(url);
    if (response.status == 200) {
        if (response.ok) {
            let json = await response.json();
            let res = json["result"];
            errorUsernameMessage.set(json["message"]);
            return json["result"];
        }
    } else if (response.status == 404) {
        errorAlertMessage.set("Сервер не доступен. Повторите попытку позже.");
        console.log("Сервер не доступен. Повторите попытку позже.");
        return false;
    }
    return false;
}

export async function isUniqueEmail() {
    let key_ = "";
    let unsubscribe3 = key.subscribe(value => {
        key_ = value;
    });

    let email_ = "";
    let unsubscribe2 = email.subscribe(value => {
        email_ = value;
    });

    let url = "/is_unique/?key=" + key_ + "&email=" + email_;
    let response = await fetch(url);
    if (response.status == 200) {
        if (response.ok) {
            let json = await response.json();
            let res = json["result"];
            errorEmailMessage.set(json["message"]);
            return json["result"];
        }
    } else if (response.status == 404) {
        errorAlertMessage.set("Сервер не доступен. Повторите попытку позже.");
        console.log("Сервер не доступен. Повторите попытку позже.");
        return false;
    }
    return false;
}

function sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
}

export async function sendRegistration() {
    let key_ = "";
    let unsubscribe = key.subscribe(value => {
        key_ = value;
    });

    let username_ = "";
    let unsubscribe1 = username.subscribe(value => {
        username_ = value;
    });

    let password_ = "";
    let unsubscribe2 = password.subscribe(value => {
        password_ = value;
    });

    let confirmPassword_ = "";
    let unsubscribe3 = confirmPassword.subscribe(value => {
        confirmPassword_ = value;
    });

    let email_ = "";
    let unsubscribe4 = email.subscribe(value => {
        email_ = value;
    });

    let errorUsernameMessage_ = "";
    let unsubscribe5 = errorUsernameMessage.subscribe(value => {
        errorUsernameMessage_ = value;
    });

    let errorEmailMessage_ = "";
    let unsubscribe6 = errorEmailMessage.subscribe(value => {
        errorEmailMessage_ = value;
    });

    let errorPasswordMessage_ = "";
    let unsubscribe7 = errorPasswordMessage.subscribe(value => {
        errorPasswordMessage_ = value;
    });
    if (errorPasswordMessage_ == "OK" && errorEmailMessage_ == "OK" &&
        errorUsernameMessage_ == "OK" && email_.length > 0 && password_ == confirmPassword_ && username_.length > 0) {
        data = {
            "type": "ByEmail",
            "key": key_,
            "username": username_,
            "first_name": username_,
            "last_name": username_,
            "email": email_,
            "password": password_,
            "password1": password_,
        }
        let url = "/accounts/signup/";
        let response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
        });

        if (response.status == 200) {
            if (response.ok) {
                let json = await response.json();
                console.log(json["result"]);
                if (json["result"]) {
                    Swal.fire({
                        title: "Вы успешно зарегистрированы!",
                        text: "Спасибо за регистрацию, вам нужно подтвердить свой email! " +
                            "Вы будете перенаправлены на станицу входа!",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success",
                        icon: "success"
                    }).then(function() { window.location.href = "/profile_journal/"; });
                } else {
                    Swal.fire({
                        title: "Ошибка",
                        text: "В результате отправки данных произошла ошибка, попробуйте попытку позже",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-warning",
                        icon: "warning"
                    });
                }
                return json["result"];
            } else {
                errorAlertMessage.set("Ошибка ответа сервера. Повторите попытку позже.");
                return false;
            }
        } else if (response.status == 404) {
            errorAlertMessage.set("Сервер не доступен. Повторите попытку позже.");
            console.log("Сервер не доступен. Повторите попытку позже.");
            return false;
        }
        return true;
    }
    return false;
}

export async function sendTgRegistration() {
    let key_ = "";
    let unsubscribe = key.subscribe(value => {
        key_ = value;
    });

    let username_ = "";
    let unsubscribe1 = username.subscribe(value => {
        username_ = value;
    });

    let confirmation_code_ = "";
    let unsubscribe2 = confirmationСode.subscribe(value => {
        confirmation_code_ = value;
    });

    let errorUsernameMessage_ = "";
    let unsubscribe5 = errorUsernameMessage.subscribe(value => {
        errorUsernameMessage_ = value;
    });

    if (errorUsernameMessage_ == "OK" && confirmation_code_.length > 0 && username_.length > 0) {
        data = {
            "type": "Telegram",
            "key": key_,
            "username": username_,
            "first_name": username_,
            "last_name": username_,
            "confirmation_code": confirmation_code_,
        }
        let url = "/accounts/signup/";
        let response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
        });

        if (response.status == 200) {
            if (response.ok) {
                let json = await response.json();
                console.log(json["result"]);
                if (json["result"]) {
                    Swal.fire({
                        title: "Вы успешно зарегистрированы!",
                        text: "Вы будете перенаправлены на журнал задач!",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success",
                        icon: "success"
                    }).then(function() { window.location.href = "/profile_journal/"; });
                } else {
                    Swal.fire({
                        title: "Ошибка",
                        text: "В результате отправки данных произошла ошибка, попробуйте попытку позже",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-warning",
                        icon: "warning"
                    });
                }
                return json["result"];
            } else {
                errorAlertMessage.set("Ошибка ответа сервера. Повторите попытку позже.");
                return false;
            }
        } else if (response.status == 404) {
            errorAlertMessage.set("Сервер не доступен. Повторите попытку позже.");
            console.log("Сервер не доступен. Повторите попытку позже.");
            return false;
        }
        return true;
    }
    return false;
}